module.exports = __webpack_public_path__ + "assets/a21f3f9e88c52fba5361732534b6d83e.png";